import BackArrow from "@assets/svg/BackArrow";
import Text from "@components/AppText";
import { normalize } from "@constants/metrics";
import testIds from "@constants/testIds";
import { colors } from "@constants/theme";
import React, { useState } from "react";
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { useSelector } from "react-redux";
import BasicInfo from "@components/Profile/BasicInfo";
import t from "@constants/localization";
import SuccessModal from "@screens/RejectedCl/Success";

const PATH = "screens/ProfileInfo/BasicInfo/index";

export default function EditBasicInfo({ navigation }) {
  const { clDropDownOptions = [], ...userDetails } = useSelector(
    ({ auth: { user } }) => user,
  );
  const [isSuccess, setIsSuccess] = useState(false);
  const goBackHandler = () => {
    navigation.goBack();
  };
  return (
    <View
      testID={testIds.BasicInfoProfile}
      style={{ flex: 1, backgroundColor: "white" }}
    >
      <View style={styles.topNavContainer}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <TouchableOpacity onPress={goBackHandler} style={styles.arrowCont}>
            <BackArrow />
          </TouchableOpacity>
          <Text bold fontType="head1">
            {t(`${PATH}/profile`)}
          </Text>
        </View>
      </View>
      <SuccessModal
        message={t(`${PATH}/profileDetailsSubmitted`)}
        onPress={() => navigation.navigate("ProfileMain")}
        visible={isSuccess}
      />
      <ScrollView>
        <View style={{ flex: 1 }}>
          <BasicInfo
            basicDetails={userDetails}
            clDropDownOptions={clDropDownOptions}
          />
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  topNavContainer: {
    flexDirection: "row",
    paddingVertical: normalize(18),
    paddingHorizontal: normalize(11),
    backgroundColor: colors.white,
    alignItems: "center",
    alignContent: "space-around",
    justifyContent: "space-between",
  },
  arrowCont: {
    marginRight: normalize(20),
  },
});
